export const getAverageValues = (numerator: number, denominator: number) => (denominator ? (numerator / denominator).toFixed(1) : '-')
